// Readers
import partKitReader from '@tekion/tekion-base/readers/PartKit';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var getPartKitOptionLabel = function getPartKitOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var partKitNumber = partKitReader.partKitNumber(option);
  var description = partKitReader.description(option);
  if (description) {
    return "".concat(partKitNumber, " - ").concat(description, " (").concat(__('Kit'), ")");
  }
  return "".concat(partKitNumber, " (").concat(__('Kit'), ")");
};
var getPartKitOptionValue = partKitReader.id;
var PART_KIT_OPTION_CONFIG = {
  getOptionLabel: getPartKitOptionLabel,
  getOptionValue: getPartKitOptionValue
};
export default PART_KIT_OPTION_CONFIG;